import React, { Fragment, useState } from "react";

import { useBaseDialog } from "@common/components/Dialog/BaseDialog";
import { MediaPreviewDialog } from "@common/components/Dialog/MediaPreviewDialog";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { Attachment } from "@common/models";
import { AttachmentButtons } from "@main/pages/shared/components/Attachments/AttachmentButtons/AttachmentButtons";
import * as Styled from "@main/pages/shared/components/Attachments/ImageAttachment/ImageAttachment.styles";
import { CSSProperties } from "styled-components";

interface Props {
  style?: CSSProperties;
  attachment?: Attachment;
  onRemoveClick?: (attachment: Attachment) => void;
}

export const ImageAttachment = ({ style, attachment, onRemoveClick }: Props) => {
  const [hover, setHover] = useState(false);

  const modal = useBaseDialog({});
  const showModal = () => {
    modal.setOpen(true);
  };

  const hideModal = () => {
    modal.setOpen(false);
  };

  if (!attachment?.url) return <Fragment />;

  function renderImagePreviewModal() {
    return (
      <MediaPreviewDialog
        modal={modal}
        onClick={() => hideModal()}
      >
        <Styled.ModalImage
          src={attachment?.url}
          alt="screenshot"
        />
      </MediaPreviewDialog>
    );
  }

  return (
    <Tooltip
      text="Zoom"
      position="top"
      style={{ height: "100%" }}
    >
      <Styled.ImageContainer
        style={style}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Styled.Image
          onClick={() => attachment?.url && showModal()}
          src={attachment?.url}
          alt="screenshot"
          loading="lazy"
        />

        {hover && (
          <AttachmentButtons
            attachment={attachment}
            onRemoveClick={onRemoveClick}
          />
        )}

        {renderImagePreviewModal()}
      </Styled.ImageContainer>
    </Tooltip>
  );
};
